import { Navigate, useLocation } from 'react-router';
import type { ReactNode } from 'react';
import { useAuth } from '@/lib/use-auth';

interface RequireAuthProps {
  children: ReactNode;
  /** When true, also allow `must_change` users (used by /change-password). */
  allowMustChange?: boolean;
}

export function RequireAuth({ children, allowMustChange = false }: RequireAuthProps) {
  const { status } = useAuth();
  const location = useLocation();

  if (status === 'loading') {
    return (
      <div className="grid min-h-[40vh] place-items-center text-sm text-slate-500">Loading…</div>
    );
  }

  if (status === 'guest') {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  if (status === 'must_change' && !allowMustChange) {
    return <Navigate to="/change-password" replace />;
  }

  return <>{children}</>;
}
